import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../../core';
import { UsuarioFilter } from '../../filter';
import { usuarioPerfilAtendente } from '../../usuario-perfil';
import { usuarioAtivo } from '../../usuario-situacao';
import { UsuarioCrudHttpService } from '../../services';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';

@Component({
    selector: 'sgt-usuario-atendente-multiselect',
    templateUrl: './usuario-atendente-multiselect.component.html',
    styleUrls: ['./usuario-atendente-multiselect.component.less']
})
export class UsuarioAtendenteMultiselectComponent implements OnInit {
    /** Atendentes selecionados */
    @Input() idsAtendentes: number[];
    /** Ao alterar a seleção dos atendentes */
    @Output() idsAtendentesChange = new EventEmitter<number[]>();

    /** Se deve exibir somente os atendentes ativos */
    @Input() somenteAtivos = false;

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todos';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhum Atendente';
    @Input() checked = 'Atendente';
    @Input() checkedPlural = 'Atendentes';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todos Selecionados';
    @Input() searchEmptyResult = 'Nenhum atendente encontrado';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[];

    constructor(private messageService: MessageService,
                private usuarioCrudHttpService: UsuarioCrudHttpService) { }

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-atendente ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria os tipos de bonificações para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        const filter = new UsuarioFilter();
        filter.perfil = usuarioPerfilAtendente.id; // Atendentes
        // Somente Ativos
        if (this.somenteAtivos) {
            filter.situacao = usuarioAtivo.id;
        }

        this.usuarioCrudHttpService.searchWithFilter(filter, null, null, null, null, null)
            .pipe(
                take(1)
            )
            .subscribe(
                response => {
                    if (response && response.data) {
                        response.data.forEach(entity => {
                            selects.push({
                                id: entity.id,
                                name: entity.nome
                            });
                        });
                        this.options = selects;
                    }
                },
                (error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao pesquisar os atendentes', error);
                }
            );
    }

    /** Ao alterar a seleção dos atendentes */
    onChange() {
        this.idsAtendentesChange.emit(this.idsAtendentes);
    }
}
